// import Vue from 'vue'
import axios from 'axios'
import { VueAxios } from './axios'

// 创建 axios 实例
// http://test.miniapp.microbooks.cn/web/getJsSdkConfig
const service = axios.create({
  baseURL: 'https://mini.digitalmini.cn/',
  timeout: 60000, // 请求超时时间
  withCredentfials: false
})
// 正式服
// const service = axios.create({
//   baseURL: process.env.NODE_ENV === 'production' ? '/api/' : 'http://api.microbooks.cn/', // api base_url
//   timeout: 60000, // 请求超时时间
//   withCredentials: false
// })

// request interceptor
service.interceptors.request.use(config => {
  // let token = Vue.ls.get(ACCESS_TOKEN)
  // if (token) {
  //   const tokenType = Vue.ls.get(TOKEN_TYPE)
  //   token = tokenType + ' ' + token
  //   config.headers.Authorization = token
  // }
  return config
}, error => { // 请求错误处理
  console.log('------------error-------------')
  console.log(error)
  // notification.error({
  //   message: '数据请求错误',
  //   description: error
  // })
})

// response interceptor
service.interceptors.response.use((response) => {
  // store.commit('LOADING_SHOW', false)
  const data = response.data
  if (data.status === 1) {
    return Promise.resolve(data.info)
  } else {
    if (data.info) {
      if (data.info.errcode === 1001) { // 未登录，去登录页面
        // notification.error({
        //   message: '验证失效，需要重新登录'
        // })
        // store.dispatch('Logout').then(() => {
        //   setTimeout(() => {
        //     window.location.reload()
        //   }, 1500)
        // })
      } else if (data.info.errcode === 1018) {
        return Promise.reject(data.info)
      } else {
        // notification.error({
        //   message: 'error',
        //   description: data.msg
        // })
      }
      return Promise.reject(data)
    }
  }
}, (err) => { // 请求错误处理
  // store.commit('LOADING_SHOW', false)
  console.log(err)
  if (err.response) {
    // if (err.response.data.status === 401) {
    //   notification.error({
    //     message: '验证失效，需要重新登录'
    //   })
    //   store.dispatch('Logout').then(() => {
    //     setTimeout(() => {
    //       window.location.reload()
    //     }, 500)
    //   })
    // } else {
    //   store.commit('LOADING_SHOW', false)
    //   notification.error({
    //     message: '接口错误'
    //   })
    // }
  }
  return Promise.reject(err)
})

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js